<script lang="ts" setup>
import type { TruckDto } from "@/api/trucks/dto/truck.dto";
import { computed } from "vue";
import { TruckStatus } from "@/data/truck";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const props = withDefaults(
  defineProps<{
    truck: TruckDto;
    light?: boolean;
  }>(),
  {
    light: false,
  },
);

const classes = computed(() => {
  if (props.truck?.archived) {
    return "bg-grey-darken-2 text-white";
  }
  switch (props.truck.status) {
    case TruckStatus.Available:
      return !props.light ? "bg-green-lighten-2 text-white" : "bg-white text-green-lighten-2";
    case TruckStatus.InRoute:
      return "bg-amber-lighten-2 text-grey-darken-3";
    case TruckStatus.WillBeAvailable:
      return !props.light ? "bg-indigo-lighten-2 text-white" : "bg-white text-indigo-lighten-2";
    case TruckStatus.NotAvailable:
      return "bg-grey-lighten-3 text-grey-darken-3";
    case TruckStatus.OnHold:
      return !props.light ? "bg-red-lighten-2 text-white" : "bg-white text-red-lighten-2";
    default:
      return "bg-grey-lighten-4 text-grey-darken-3";
  }
});
</script>

<template>
  <v-chip :class="classes" class="rounded-xl px-2 pa-1" density="comfortable" size="small">
    {{ t("trucks.status-" + truck.status) }}
  </v-chip>
</template>

<style lang="scss" scoped></style>
